import React, { memo } from "react";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import theme from "theme";

const FieldBody = memo(({ title, value, color = null }) => {
	const classes = useStyles();
	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.title }}>{title}</Grid>
			<Grid
				classes={{ root: classes.value }}
				style={{
					color: color ? color : theme.palette.primary.contrastText
				}}
			>
				{value}
			</Grid>
		</Grid>
	);
});

export default FieldBody;
